import { render, staticRenderFns } from "./Forgotten.vue?vue&type=template&id=c48cb582&scoped=true"
import script from "./Forgotten.vue?vue&type=script&lang=js"
export * from "./Forgotten.vue?vue&type=script&lang=js"
import style0 from "./Forgotten.vue?vue&type=style&index=0&id=c48cb582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48cb582",
  null
  
)

export default component.exports